import { useBreakpoints } from '@vueuse/core';

export const useScreenBreakpoints = () => {
  const breakpoints = useBreakpoints({
    xs: 320,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1600,
    xxl: 1920,
    screenMdMin: 1024,
  });
  const isMobileView = breakpoints.smallerOrEqual('sm');

  return {
    breakpoints,
    isMobileView,
  };
};
